module.exports = __webpack_public_path__ + "assets/images/fruits_g.5c0bd23e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/fruits_g.png
// module id = 711
// module chunks = 1